export enum TopologyElementPrefix {
  node = 'node_',
  voip_peer = 'voippeer_',
  peer_connection = 'peerConnection_'
}
